export function getFio(user) {
    return [user.surname, user.name, user.patronymic].filter(Boolean).join(' ');
}

export function checkName(name, fieldName, onlyCyrillic = false) {
    let pattern;
    let err;
    if (onlyCyrillic) {
        pattern = /^[а-яё\-\' ]+$/ig;
        err = `${fieldName} может содержать только символы: А-Я, а-я, -, ' или пробел`;
    } else {
        pattern = /^[a-zа-яё\-\' ]+$/ig;
        err = `${fieldName} может содержать только символы: A-Z, a-z, А-Я, а-я, -, ' или пробел`;
    }
    if (!name.match(pattern)) {
        return err;
    }

    pattern = /[a-zа-яё]+/ig;
    if (!name.match(pattern)) {
        return `${fieldName} не может содержать только символы`;
    }

    pattern = /(^[\-\' ])|([\-\' ]$)/;
    if (name.match(pattern)) {
        return `${fieldName} не может содержать символы в начале и в конце`;
    }

    pattern = /[\-\']{2,}/;
    if (name.match(pattern)) {
        return `${fieldName} не может содержать подряд идущие символы`;
    }

    return "";
}